import axiosIns from '@/api/axios';
import axiosInsAcademy from '@/api/axios-ugems-academy.js';

const BIB_COMPANY = 'PT. BORNEO INDOBARA';
const BIB_COMPANY_ID = 7003;

const BIB_ORG_PARAMS = {
  bibOnly: true,
  companyId: BIB_COMPANY_ID,
  company_id: BIB_COMPANY_ID,
  company: BIB_COMPANY,
};

const BIB_EMPLOYEE_PARAMS = {
  ...BIB_ORG_PARAMS,
  limit: 25,
};

export default {
  // Get BIB divisions (backend also scopes to bibCompanyId)
  getDivisions(filters = {}) {
    const params = typeof filters === 'string' ? { department: filters } : (filters || {});
    return axiosInsAcademy.get('/divisions', {
      params: { ...BIB_ORG_PARAMS, ...params },
    });
  },

  // Get BIB departments independently (division filter is optional, not required)
  getDepartments(filters = {}) {
    const params = typeof filters === 'string' ? { division: filters } : filters;
    return axiosInsAcademy.get('/departments', {
      params: { ...BIB_ORG_PARAMS, ...params },
    });
  },

  // Get BIB positions independently (division/department filters are optional)
  getPositions(filters = {}) {
    const params = typeof filters === 'string' ? { department: filters } : filters;
    return axiosInsAcademy.get('/positions', {
      params: { ...BIB_ORG_PARAMS, ...params },
    });
  },

  // Search BIB employees independently (no sequential parent filter required)
  getEmployees(filters = {}) {
    const params = typeof filters === 'string'
      ? { search: filters }
      : { ...filters };

    // Prefer searchable endpoint so employee can be chosen freely by name/NIK
    return axiosInsAcademy.get('/employees/search', {
      params: { ...BIB_EMPLOYEE_PARAMS, ...params },
    });
  },

  // Get all training with pagination
  getTrainings(params = {}) {
    const queryParams = new URLSearchParams();
    
    if (params.page) queryParams.append('page', params.page);
    if (params.limit) queryParams.append('limit', params.limit);
    if (params.search) queryParams.append('search', params.search);
    
    const queryString = queryParams.toString();
    return axiosIns.get(`/training${queryString ? '?' + queryString : ''}`);
  },

  // Get training mapping to check selected trainings
  getTrainingMapping(params) {
    return axiosInsAcademy.get('/training-mapping', { params });
  },

  // Save training mapping
  saveTrainingMapping(data) {
    return axiosInsAcademy.put('/training-mapping', data);
  }
};
